<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="title"
      [canGoBack]="!cantGoBack" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">

    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


      @if (!cancellingAccount) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'There are several ways to cancel to accomodate your needs:'" />
        </tidy-row>
        <tidy-card>
          <tidy-row [align]="'center'">
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [header]="'Cancel All Jobs'" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="'Use this if you want to make sure you have nothing future scheduled.'" />
            </tidy-row>
          </tidy-row>
          <tidy-row>
            <tidy-button
              [text]="'Cancel All Jobs'"
              [action]="boundConfirmcancelAllJobs"
              class="secondary" />
          </tidy-row>
        </tidy-card>
        @if (isAccountOwner) {
          <tidy-card>
            <tidy-row [align]="'center'">
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [header]="'Cancel Account & Delete Data'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="'Use this if you are looking to delete as much information as possible.'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="'We do not recommend doing this if you need any job or billing history in the future or are looking for a refund, as that information can be relevant to you.'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="'Please resolve any job or billing issue first before deleting your data.'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="'You cannot do this if you have a pending charge or refund that has not fully processed. If you need billing help, remember to contact the TIDY Concierge.'" />
              </tidy-row>
            </tidy-row>
            <tidy-row>
              <tidy-button
                [text]="'Cancel Jobs & Delete Data'"
                [action]="boundCancelAccount"
                class="secondary" />
            </tidy-row>
          </tidy-card>
        }
      }

      @if (cancellingAccount) {
        <tidy-card>
          <tidy-text
            [body]="'As your account data is important to resolve any job or billing related issues, please confirm the following:'" />
          <tidy-checkbox
            formControlName="firstCheck"
            [form]="form.controls.firstCheck"
            [items]="[{viewValue: 'I have no outstanding job related issues.', value: true}]" />
          <tidy-checkbox
            formControlName="secondCheck"
            [form]="form.controls.secondCheck"
            [items]="[{viewValue: 'I have no outstanding billing related issues.', value: true}]" />
          <tidy-checkbox
            formControlName="thirdCheck"
            [form]="form.controls.thirdCheck"
            [items]="[{viewValue: 'I understand that deleting my account cannot be un-done.', value: true}]" />
        </tidy-card>
        <tidy-error-message
          [text]="errorMessage" />
        <tidy-two-column-row>
          <tidy-button
            [text]="'Go Back'"
            [action]="boundStopCancellingAccount"
            class="secondary" />
          <tidy-button
            [text]="'Cancel Account'"
            [action]="boundConfirmAccountCancellation"
            class="primary" />
        </tidy-two-column-row>
      }

    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
